// extracted by mini-css-extract-plugin
export default {"root":"gift_card_pdf_details_root__Z4SFt","pdfExplanationButton":"gift_card_pdf_details_pdfExplanationButton__upRRM"};